<template>
  <div class="monthly top-up-type summary-list">
    <slot name="txtBefore"></slot>
    <div class="summary-row headline" id="topup-tct-text-activation-summary">
      <div class="label txtHeader">
        <slot name="txtMonthlyHeader">Zeitraum</slot>
      </div>
      <div class="value">
        Monatliche Aufladung
      </div>
    </div>

    <div class="summary-row top-up-content">
      <div class="label">
        <slot name="txtTopUpAmount">Aufladebetrag</slot>
      </div>
      <div class="value">
        {{ price(topUpInfo.amount) }}
      </div>
    </div>

    <slot name="txtDesc">
      <p>
        Jeweils am {{ topUpInfo.trigger }}. eines Monats wird der ausgewählte Aufladebetrag auf dein mobil Konto
        aufgeladen.&nbsp;Die Einrichtung der monatlichen Aufladung erfolgt nach Erhalt deiner SIM-Karte über die von dir
        ausgewählte Zahlungsart.
      </p>
    </slot>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { stepName as topUpStep } from '../TopUp/EnterTopUpAndPayment.vue'
import price from '@/mixins/price'

export default {
  name: 'ShowMonthly',
  props: {
    topUpInfo: {
      type: Object
    },
    changeBtn: {
      default: true
    }
  },
  computed: {
    slotData() {
      return {
        topUpInfoTrigger: this.topUpInfo.trigger
      }
    }
  },
  methods: {
    goToTopUpStep: function() {
      this.goToStep(topUpStep)
    },
    ...mapMutations('activation', ['goToStep'])
  },
  mixins: [price]
}
</script>
